module.exports = "/dist/images/rentlio.f04c6dd1.svg";